import { t } from 'i18next';
import { startCase } from 'lodash';

import { PricingProfilePricingType, PricingSourceStatus } from 'pricing/enums';
import { costingProfileDetailsPath, pricingProfileDetailsPath } from 'pricing/routes/routePaths';
import { ICostSourceData, IPriceSourceData, IPricingSource } from 'pricing/types';

const BaseSourceHelper = {
  getCostSource: ({
    costSourceId,
    costSourcePricingProfileId,
    costSourcePricingProfilePricingType,
    costSourcePricingProfileName,
    costSourceStatus,
  }: ICostSourceData): IPricingSource => {
    return {
      id: costSourceId,
      pricingProfileId: costSourcePricingProfileId,
      pricingProfilePricingType: costSourcePricingProfilePricingType,
      pricingProfileName: costSourcePricingProfileName,
      status: costSourceStatus,
    };
  },

  getPriceSource: ({
    priceSourceId,
    priceSourcePricingProfileId,
    priceSourcePricingProfileName,
    priceSourceStatus,
  }: IPriceSourceData): IPricingSource => {
    return {
      id: priceSourceId,
      pricingProfileId: priceSourcePricingProfileId,
      pricingProfileName: priceSourcePricingProfileName,
      status: priceSourceStatus,
    };
  },

  getPricingProfileName: (pricingSource: IPricingSource) => {
    if (!pricingSource) {
      return '';
    }

    const { pricingProfileName, pricingProfilePricingType, status } = pricingSource;

    if (PricingSourceStatus.PRICING_PROFILE_REMOVED === status) {
      switch (pricingProfilePricingType) {
        case PricingProfilePricingType.COSTING:
          return startCase(t('labelCostingProfileRemoved'));
        case PricingProfilePricingType.PRICING:
        default:
          return startCase(t('labelPricingProfileRemoved'));
      }
    }

    return pricingProfileName || '';
  },

  getPricingProfileUrl: (pricingSource: IPricingSource) => {
    const { pricingProfileId, pricingProfilePricingType } = pricingSource;

    if (!pricingProfileId) {
      return null;
    }

    switch (pricingProfilePricingType) {
      case PricingProfilePricingType.COSTING:
        return costingProfileDetailsPath(pricingProfileId);
      case PricingProfilePricingType.PRICING:
      default:
        return pricingProfileDetailsPath(pricingProfileId);
    }
  },
};

export default BaseSourceHelper;
